







































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import VueChatScroll from 'vue-chat-scroll';
import Btn from '../Button/Btn.vue';
import playSound from '../../utils/sounds';

Vue.use(VueChatScroll);
const preventGameActions = (e: KeyboardEvent): void => {
  if (e.code !== 'Tab') e.stopImmediatePropagation();
};

@Component({
  computed: {
    ...mapGetters([
      'getUsers',
      'getCurrentName',
      'getCompletedLength',
      'getHistory',
      'getId',
    ]),
  },
  components: {
    Btn,
  },
})
export default class Chat extends Vue {
  message = '';

  getCurrentName!:string;

  getId!: string;

  getHistory!: [];

  unread = false;

  minimized = true;

  playSound = playSound;

  preventGameActions = preventGameActions;

  chatArrow = '<i class="fa-regular fa-messages"></i>';

  chatInputRef = (): HTMLElement => this.$refs.chatInput as HTMLElement;

  @Watch('getHistory') onHistoryChange(): void {
    this.playSound('message');
    if (this.getHistory.length > 0) {
      if (this.minimized) {
        this.unread = true;
      } else {
        this.unread = true;
        setTimeout(() => {
          this.unread = false;
        }, 800);
      }
    }
  }

  toggleWindow():void {
    this.minimized = !this.minimized;
    if (!this.minimized) this.chatInputRef().focus();
    if (this.minimized) this.chatInputRef().blur();
    this.unread = false;
    this.chatArrow = this.minimized
      ? '<i class="fa-regular fa-messages"></i>'
      : '<i class="fa-regular fa-arrow-down-from-dotted-line"></i>';
  }

  checkMyName(name: string): boolean {
    if (name === this.getCurrentName) return true;
    if (name === `Guest_${this.getId[0]}${this.getId[4]}${this.getId[this.getId.length - 1]}`) return true;
    if (name === this.getId) return true;
    return false;
  }

  sendMessage(): void {
    const name = this.getCurrentName || this.getId;
    if (this.message) this.$socket.emit('sendMessage', { name, message: this.message });
    this.message = '';
  }

  created(): void {
    document.addEventListener('keydown', (e) => {
      if (e.code === 'Tab') {
        this.toggleWindow();
        e.preventDefault();
      }
    });
  }
}
